<template>
<div>
  <thingListHeader />
  <thingsFirst />
</div>
</template>

<script>
  import thingListHeader from "../../components/Pages/Things/Headers/thingsList/thingListHeader";
  import thingsFirst from "../../components/Pages/Things/Things/thingFirstLevel";
  import {mapMutations} from 'vuex'
  import {projectPageMixin} from "../../mixins/projects/projectPageMixin";

  export default {
    name: "ThingsInProject",
    components: {thingListHeader, thingsFirst},
    mixins: [projectPageMixin],
    methods: {
      ...mapMutations({
        setFullSidebar: 'sidebar/SET_DASHBOARD',
        setLinkName: 'sidebar/SET_LINK_NAME',
        setRouteName: 'sidebar/SET_ROUTE_NAME'
      })
    },
    beforeRouteEnter(to,from,next) {
      next(vm => {
        vm.setFullSidebar(false);
        vm.setLinkName('projectThings');
        vm.setRouteName(vm.projectMother.name);
      })
    },
  }
</script>

<style lang="scss" scoped>
</style>
